import Typo from "@/src/components/atom/Typo";
import { FOOTER_LINKS } from "@/src/constants/footerLinks";
import { useSignupStatus } from "@/src/hooks/useSignupStatus";
import EXPORTER_PRIVATE_PATH from "@/src/routes/exporter/path";
import PUBLIC_PATH from "@/src/routes/public/path";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { styled } from "styled-components";

const PublicPageFooter = () => {
  const { t, i18n } = useTranslation();
  const { isFirstStepSignup, normalizedUser } = useSignupStatus();

  const homePath = normalizedUser ? EXPORTER_PRIVATE_PATH.HOME : PUBLIC_PATH.ROOT;

  const handleHomeClick = (e: React.MouseEvent) => {
    if (isFirstStepSignup) {
      e.preventDefault();
      return;
    }

    const currentLang = i18n.language;
    const mainPageSupportedLangs = ["ko", "en"];

    if (!mainPageSupportedLangs.includes(currentLang)) {
      i18n.changeLanguage("en");
    }
  };

  return (
    <Footer>
      <FooterLink to={homePath} onClick={handleHomeClick}>
        <Typo typoType="b10m" color="gray7">
          {t("signup:v2.home")}
        </Typo>
      </FooterLink>
      <FooterLink to={FOOTER_LINKS.TERMS_OF_USE}>
        <Typo typoType="b10m" color="gray7">
          {t("signup:v2.terms")}
        </Typo>
      </FooterLink>
      <FooterLink to={FOOTER_LINKS.PRIVACY_POLICY}>
        <Typo typoType="b10m" color="gray7">
          {t("signup:v2.privacy")}
        </Typo>
      </FooterLink>
      <FooterLink to={FOOTER_LINKS.CONTACT_US}>
        <Typo typoType="b10m" color="gray7">
          {t("signup:v2.contact")}
        </Typo>
      </FooterLink>
      <Typo typoType="b10m" color="gray7">
        {t("signup:v2.copyright")}
      </Typo>
    </Footer>
  );
};

export default PublicPageFooter;

const Footer = styled.footer`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 4px 10px 8px;
`;

const FooterLink = styled(Link)`
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }
`;
